import { Typography } from "@mui/material";
import ArtifactAgentNote from "./ArtifactAgentNote";

interface Props {
  lines: string[];
}

const ArtifactAgentNotCopied = ({ lines }: Props) => {
  if (lines.length === 0) {
    return (
      <Typography variant="caption" color="textSecondary">
        Everything in the picture was copied.
      </Typography>
    );
  }
  return <ArtifactAgentNote severity="info" title="Not copied" lines={lines} />;
};

export default ArtifactAgentNotCopied;
